<div class="animated fadeIn" style="overflow: hidden;">
    <div class="card">

        <div class="card-body" [style]="{'border': '1px solid red!important;'}">

            <div class="row">


                <p-table #dt [columns]="cols" [loading]="loading" selectionMode="single" [(selection)]="selectedProduit"
                    [value]="produits" [globalFilterFields]="['designation','designationAn' ]" [scrollable]="true">


                    <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix" style="text-align: left">

                            <button pButton icon="pi pi-times" (click)="removeProduit()"  label='Remove' [disabled]='!selectedProduit'
                                class="btn btn-sm btn-def">
                            
                            </button>

                            <button pButton  icon="pi pi-pencil" (click)="isVisible=true"  label='Editer' [disabled]='!selectedProduit'
                                class="btn btn-sm btn-def">
                               </button>
                            <button pButton icon="pi pi-plus"  (click)="prepareProduit()"  label='New' class="btn btn-sm btn-def">
                              </button>

                            <input type="text" style="float: right;width:auto" pInputText placeholder="Global Filter"
                                (input)="dt.filterGlobal($event.target.value, 'contains')">
                            <i class="fa fa-search" style="margin:4px 4px 0 0;float: right;"></i>
                            <span *ngIf='produits' style="float: right;">

                                {{produits.length}} Produits
                            </span>


                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>


                        <tr>
                            <th *ngFor="let col of columns">
                                {{col.header}}
                            </th>
                        </tr>
                        <tr>
                            <th *ngFor="let col of columns" [ngSwitch]="col.field" [pSortableColumn]="col.field">
                            
                                   
                                    
                                <p-dropdown appendTo="body"  *ngSwitchCase="'specifique'" [options]="ouiNon"
                                [style]="{'width':'100%'}"
                                (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>
                      

                                <p-dropdown appendTo="body"  *ngSwitchCase="'publicite'" [options]="ouiNon"
                                    [style]="{'width':'100%'}"
                                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>

                                <input  (click)="$event.stopPropagation()" *ngSwitchDefault pInputText type="text"
                                    (input)="dt.filter($event.target.value, col.field, 'contains')">
                                <p-sortIcon [style]="{'width':'5px!important'}" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>



                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">



                            <td *ngFor="let col of columns" [ngSwitch]="col.field">
                                <span *ngSwitchCase="'specifique'"> <span *ngIf="rowData.specifique">Oui</span><span
                                        *ngIf="!rowData.specifique">Non</span></span>
                                <span *ngSwitchCase="'publicite'"> <span *ngIf="rowData.publicite">Oui</span><span
                                        *ngIf="!rowData.publicite">Non</span></span>

                                <span *ngSwitchDefault> {{rowData[col.field]}}</span>

                            </td>





                        </tr>
                    </ng-template>



                </p-table>





            </div>
        </div>


    </div>

</div>
 
<p-dialog  position="top"  *ngIf="selectedProduit" [(visible)]="isVisible" [modal]="true" [responsive]="true"
    [style]="{width: '900px',height: '500px', minWidth: '400px'}" [maximizable]="false" appendTo='body'>

<p-header>Editer Produit</p-header>
<div style="height: 400px;">
    <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            Designation
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
            <input type="text" pInputText [(ngModel)]="selectedProduit.designation">
        </div>
    </div>
    <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            Designation En
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
            <input pInputText type="text" [(ngModel)]="selectedProduit.designationAn">

        </div>
    </div>
    <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            Prix Dinar
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
            <input pInputText type="number" [(ngModel)]="selectedProduit.prixDzd">

        </div>
    </div>
    <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            Prix Euro
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
            <input pInputText type="number" [(ngModel)]="selectedProduit.prixEuro">

        </div>
    </div>
    <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            Prix Dollar
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
            <input pInputText type="number" [(ngModel)]="selectedProduit.prixDol">

        </div>
    </div>
    <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            M. Spécifique
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
            <p-inputSwitch [(ngModel)]="selectedProduit.specifique"></p-inputSwitch>

        </div>
    </div>
    <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            Publicité
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
            <p-inputSwitch [(ngModel)]="selectedProduit.publicite"></p-inputSwitch>

        </div>
    </div>
</div>
    <footer>
        <button style="float: right;width: 200px;" pButton (click)="saveProduit()" label='Editer' class="btn-def"> </button>
    </footer>


</p-dialog>